// Basic Parameters
export const TILE_SIZE = 'tileSize'
export const TILE_SIZE_LABEL = 'Tile Size'
export const RING_SCALE = 'ringScale'
export const RING_SCALE_LABEL = 'Ring Scale'
export const RING_DISTORTION = 'ringDistortion'
export const RING_DISTORTION_LABEL = 'Distortion'
export const KNOT_INTENSITY = 'knotIntensity'
export const KNOT_INTENSITY_LABEL = 'Knots'
export const LATEWOOD_BIAS = 'latewoodBias'
export const LATEWOOD_BIAS_LABEL = 'Sharpness'
export const RAY_STRENGTH = 'rayStrength'
export const RAY_STRENGTH_LABEL = 'Rays'
export const PORE_DENSITY = 'poreDensity'
export const PORE_DENSITY_LABEL = 'Pores'

// Advanced Parameters
export const FBM_OCTAVES = 'fbmOctaves'
export const FBM_OCTAVES_LABEL = 'FBM Octaves'
export const FBM_AMPLITUDE = 'fbmAmplitude'
export const FBM_AMPLITUDE_LABEL = 'FBM Amplitude'
export const KNOT_FREQUENCY = 'knotFrequency'
export const KNOT_FREQUENCY_LABEL = 'Knot Frequency'
export const DISTORTION_FREQ = 'distortionFreq'
export const DISTORTION_FREQ_LABEL = 'Distortion Frequency'
export const RING_NOISE_FREQ = 'ringNoiseFreq'
export const RING_NOISE_FREQ_LABEL = 'Ring Noise Frequency'
export const RAY_FREQUENCY_X = 'rayFrequencyX'
export const RAY_FREQUENCY_X_LABEL = 'Ray Frequency X'
export const RAY_FREQUENCY_Y = 'rayFrequencyY'
export const RAY_FREQUENCY_Y_LABEL = 'Ray Frequency Y'
export const KNOT_THRESHOLD_MIN = 'knotThresholdMin'
export const KNOT_THRESHOLD_MIN_LABEL = 'Knot Threshold Min'
export const KNOT_THRESHOLD_MAX = 'knotThresholdMax'
export const KNOT_THRESHOLD_MAX_LABEL = 'Knot Threshold Max'

// Pore Parameters
export const PORE_SCALE = 'poreScale'
export const PORE_SCALE_LABEL = 'Pore Size'
export const PORE_THRESHOLD_EARLY = 'poreThresholdEarly'
export const PORE_THRESHOLD_EARLY_LABEL = 'Early Wood Threshold'
export const PORE_THRESHOLD_LATE = 'poreThresholdLate'
export const PORE_THRESHOLD_LATE_LABEL = 'Late Wood Threshold'
export const PORE_THRESHOLD_RANGE = 'poreThresholdRange'
export const PORE_THRESHOLD_RANGE_LABEL = 'Threshold Range'
export const PORE_STRENGTH = 'poreStrength'
export const PORE_STRENGTH_LABEL = 'Pore Strength'

// Material Properties
export const NORMAL_STRENGTH = 'normalStrength'
export const NORMAL_STRENGTH_LABEL = 'Normal Strength'
export const ROUGHNESS_MIN = 'roughnessMin'
export const ROUGHNESS_MIN_LABEL = 'Min Roughness'
export const ROUGHNESS_MAX = 'roughnessMax'
export const ROUGHNESS_MAX_LABEL = 'Max Roughness'